<template>
  <div class="comp-goto-top" v-if="gotoVisible" @click="gotoTop" title="返回顶部">
    <span class="iconfont iconzuojiantou"></span>
  </div>
</template>

<script>
  /**
   * @author yueheqin
   * @date 2018/12/20
   * @project kaoshizhongxin-pc
   * @desc 返回顶部
   */
  import {mapState} from 'vuex'
  export default {
    name: 'comp-goto-top',
    props: {},
    data () {
      return {
      }
    },
    computed: {
      ...mapState(['scrollTop']),
      gotoVisible () {
        return this.scrollTop > 500
      }
    },
    methods: {
      gotoTop () {
        $('html').animate({scrollTop: 0}, 500)
      }
    }
  }
</script>

<style lang="less">
  .comp-goto-top {
    width: 50px;
    height: 50px;
    position: fixed;
    bottom: 100px;
    right: 80px;
    background: #dddddd;
    border-radius: 5px;
    text-align: center;
    cursor: pointer;
    opacity: 0.8;
    span{
      transform: rotate(90deg);
      display: block;
      color: #ffffff;
      line-height: 50px;
      font-size: 20px;
    }
  }
</style>
